import resume from '../assets/pdf/resume.pdf'
import ten from '../assets/png/ten.png'

export const headerData = {
    name: 'Phethani Cyril',
    title: "FrontEnd Developer",
    desciption:"Experienced Frontend Developer passionate about crafting clean and efficient code to create engaging and user friendly websites ",
    image: ten,
    resumePdf: resume
}
